const MAX_VIDEOS_PER_PAGE = 10;
const FILTER_ALL = 'tout';

export default class VimeoVideos {

  constructor($dom) {
    this.$dom = $dom;

    // Creation des filtres dynamiquement
    // On récupère le dataset (défini avec les étiquettes récupérées depuis l'api Vimeo) de chaque video pour créer les filtres
    this.$wrapper = $dom.querySelector('.videos__wrapper');
    this.$filtersList = $dom.querySelector('.videos__list');
    this.$items = $dom.querySelectorAll('.videos__item');
    this.$loadMoreBtn = document.querySelector('.videos__load-more');

    this.init();
  }

  init() {
    this.filters = [];
    this.filtersTags = [];
    this.activeFilter = '';

    this.numActiveVideos = 0;

    this.buildFilters();
    this.addEventListenersToFilters();

    this.initFilters();
    this.toggleLoadMoreBtn();

    this.$loadMoreBtn.addEventListener('click', this.onLoadMoreClick.bind(this));
  }

  buildFilters() {
    for (let i = 0; i < this.$items.length; i++) {
      const $item = this.$items[i];
      const tags = $item.dataset.tags.split('|').filter(
        function (e) {
          return e.trim().length > 0;
        });
      const $defaultButton = this.$filtersList.querySelector('button');

      if (!$item.classList.contains('hidden')) {
        for (let j = 0; j < tags.length; j++) {
          const tag = tags[j];
          if (!this.filtersTags.includes(tag)) {
            this.filtersTags.push(tag);

            const button = $defaultButton.cloneNode();
            button.classList.remove('is-active');
            button.innerText = tag;
            button.dataset.name = tag;

            const li = document.createElement('li');
            li.classList.add('videos__list--filter');
            li.appendChild(button);
            this.$filtersList.appendChild(li);
          }
        }
      }
    }

    this.$filters = document.querySelectorAll('.videos__list--filter button');
  }

  addEventListenersToFilters() {

    for (let i = 0; i < this.$filters.length; i++) {
      const filter = this.$filters[i];
      // On ajoute un listener de click sur tout les tags
      var filterListener = this.onFilterClick.bind(this);
      filter.removeEventListener('click', filterListener);
      filter.addEventListener('click', filterListener);
      filter.params = filter;
    }
  }

  onFilterClick(evt) {
    this.activateFilter(evt.target.params);
    evt.preventDefault();
  }

  chechHash() {
    let urlWithHash = location.hash.split('#')[1];
    if (urlWithHash == FILTER_ALL) urlWithHash = false;
    return urlWithHash;
  }

  getHiddenVideos() {
    var hiddenVideos;
    if ( this.chechHash() ) {
      hiddenVideos = this.$dom.querySelectorAll('.filter-' + this.activeFilter.replace(' ', '.') + '.displayed.hidden');
    } else {
      hiddenVideos = this.$dom.querySelectorAll('.videos__item.hidden');
    }
    return hiddenVideos;
  }

  initFilters() {
    const urlWithHash = this.chechHash();
    if (!urlWithHash) return;

    for (let i = 0; i < this.$filters.length; i++) {
      const filter = this.$filters[i];
      const filterString = filter.dataset.name.toLowerCase().replace(' ', '_');

      if (filterString == urlWithHash) {
        this.activateFilter(filter);
      }
    }
  }

  activateFilter(filter) {
    const filterString = filter.dataset.name.replace(' ', '_').toLowerCase();
    this.numActiveVideos = 0;

    this.$filters.forEach(filter => { filter.classList.remove('is-active') });
    filter.classList.add('is-active');

    const hash = '#' + filterString;
    location.hash = hash;

    this.activeFilter = hash.substr(1).replace('_', ' ');

    for (let i = 0; i < this.$items.length; i++) {
      const videoItem = this.$items[i];
      const videoTags = videoItem.dataset.tags.split('|').filter( function (e) { return e.trim().length > 0 });

      if (filterString != FILTER_ALL) {
        var hasTag = false;
        for (let j = 0; j < videoTags.length; j++) {
          const tag = videoTags[j].replace(' ', '_').toLowerCase();
          if (tag == filterString) {
            hasTag = true;
            break;
          }
        }
        this.toggleVideoItemDisplay(videoItem, hasTag);
      } else {
        this.toggleVideoItemDisplay(videoItem, true);
      }
    }

    this.toggleLoadMoreBtn();
    this.fade();
  }

  toggleVideoItemDisplay(videoItem, isVisible = true) {

    if (isVisible) {
      videoItem.classList.remove('not-displayed');
      videoItem.classList.remove('display-none');
      if (!videoItem.classList.contains('displayed')) videoItem.classList.add('displayed');

      if (this.numActiveVideos < MAX_VIDEOS_PER_PAGE) {
        videoItem.classList.remove('hidden');
        this.numActiveVideos += 1;
      }
    } else {
      if (!videoItem.classList.contains('hidden')) videoItem.classList.add('hidden');
      if (!videoItem.classList.contains('display-none')) videoItem.classList.add('display-none');
      if (!videoItem.classList.contains('not-displayed')) videoItem.classList.add('not-displayed');
    }

  }

  onLoadMoreClick() {
    var hiddenVideos = this.getHiddenVideos();

    if (MAX_VIDEOS_PER_PAGE < hiddenVideos.length) {
      for (let i = 0; i < MAX_VIDEOS_PER_PAGE; i++) {
        const hiddenVideo = hiddenVideos[i];
        hiddenVideo.classList.remove('hidden');
      }
    } else {
      this.$loadMoreBtn.classList.add('hidden');

      for (let i = 0; i < hiddenVideos.length; i++) {
        const hiddenVideo = hiddenVideos[i];
        hiddenVideo.classList.remove('hidden');
      }
    }

    this.fade();

    this.buildFilters();
    this.addEventListenersToFilters();
  }

  toggleLoadMoreBtn() {
    const hiddenVideos = this.getHiddenVideos();

    if (hiddenVideos.length > 0) {
      this.$loadMoreBtn.classList.remove('hidden');
    } else {
      this.$loadMoreBtn.classList.add('hidden');
    }
  }

  fade() {
    if (this.$wrapper.classList.contains('fade')) {
      this.$wrapper.classList.remove('fade');
      this.$wrapper.classList.add('fade2');
    } else {
      this.$wrapper.classList.remove('fade2');
      this.$wrapper.classList.add('fade');
    }
  }

}



// WEBPACK FOOTER //
// ./scripts/dom/VimeoVideos.js